import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import {
  Container,
  Paper,
  Typography,
  Button,
  Modal,
  Box,
  Stack,
} from "@mui/material";

const InvoiceModal = (props) => {
  const [open, setOpen] = useState(false);
  const printRef = useRef();
  const ticketsCharge = props.tripData.guestCount * props.tripData.costPerGuest;
  const itemsCharge = props.tripData.items.reduce(
    (sum, item) => sum + item.price * 1,
    0,
  );
  const totalCharge = ticketsCharge * 1 + itemsCharge * 1;
  const non_refundable_deposit = props.tripData.non_refund_deposite
    ? props.tripData.non_refund_deposite * -1
    : 0;
  console.log();
  console.log(ticketsCharge);
  console.log(itemsCharge);

  const usdFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const handlePrint = useReactToPrint({
    documentTitle: props.tripData.client
      ? props.tripData.client + " Invoice"
      : "Title",

    contentRef: printRef,
    // onAfterPrint: () => setOpen(false), // Close modal after printing
  });

  const handleOpenAndPrint = () => {
    setOpen(true);
    setTimeout(() => {
      if (printRef.current) {
        document.body.click(); // Trick Safari into registering interaction
        setTimeout(handlePrint, 300); // Small delay ensures rendering before print
      }
    }, 500);
  };

  const handleManualPrint = () => {
    if (printRef.current) {
      // document.body.click(); // Ensures Safari registers user interaction
      setTimeout(() => {
        handlePrint();
      }, 3000); // Tiny delay to allow Safari rendering
    }
  };

  return (
    <Container
      style={{ padding: "20px", backgroundColor: "#f5f5f5", overflowY: "auto" }}
    >
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          style={{
            position: "absolute",
            top: "40%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%", // Responsive width
            overflowY: "auto",
            height: "80%",
            maxWidth: "900px", // Ensures it doesn't get too big
            backgroundColor: "#ffffff", // Bright white background
            borderRadius: "12px", // Rounded corners
            boxShadow: "0px 15px 35px rgba(0, 0, 0, 0.2)", // More prominent shadow
            padding: "30px", // Increased padding for better layout
            // overflow: "hidden", // Prevents scrolling issues
            textAlign: "center", // Centers the content
          }}
        >
          <Button onClick={handleManualPrint}>print</Button>
          <Stack
            ref={printRef}
            style={{
              padding: "40px",
              width: "215.9mm", // A4 width
              height: "279.4mm", // A4 height
              margin: "0", // No margin to ensure it uses the full page
              boxSizing: "border-box",
              overflow: "hidden", // Prevent overflow
            }}
            justifyContent="space-between"
          >
            <Stack>
              <Stack direction="row" justifyContent="space-between">
                <Stack
                  alignContent="flex-start"
                  style={{ marginTop: "20px", textAlign: "left" }}
                >
                  <Typography
                    variant="h6"
                    style={{ fontWeight: "bold", marginBottom: "10px" }}
                  >
                    Candyland Adventure
                  </Typography>
                  <Typography variant="h7" style={{ padding: 0 }}>
                    641 Baltimore Pike
                  </Typography>
                  <Typography style={{ padding: 0, margin: 0 }} variant="h7">
                    Springfield, PA 19064
                  </Typography>

                  <Typography
                    variant="h7"
                    style={{ marginTop: "80px", textAlign: "left" }}
                  >
                    Bill to:
                  </Typography>
                  <Typography variant="h7">{props.tripData.client}</Typography>
                  <Typography variant="h7" style={{ padding: 0 }}>
                    {props.tripData.bill_address1}
                  </Typography>
                  <Typography style={{ padding: 0, margin: 0 }} variant="h7">
                    {props.tripData.bill_address2}
                  </Typography>
                  <Typography style={{ padding: 0, margin: 0 }} variant="h7">
                    {props.tripData.bill_city
                      ? props.tripData.bill_city + ", "
                      : ""}{" "}
                    {props.tripData.bill_state} {props.tripData.bill_zipcode}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography
                    variant="h6"
                    style={{
                      fontWeight: "bold",
                      marginBottom: "10px",
                      color: "rgb(12, 118, 240) ",
                    }}
                  >
                    Invoice
                  </Typography>
                  <Typography
                    variant="h7"
                    style={{
                      fontWeight: "bold",
                      textAlign: "left",
                    }}
                  >
                    Invoice number{" "}
                    <Typography
                      variant="subtitle1"
                      style={{
                        marginBottom: "10px",
                      }}
                    >
                      {props.tripData.date.slice(5) +
                        props.tripData._id.slice(-6).toUpperCase()}
                    </Typography>
                  </Typography>
                  <Typography
                    variant="h7"
                    style={{
                      fontWeight: "bold",
                      textAlign: "left",
                    }}
                  >
                    Date{" "}
                    <Typography variant="subtitle1">
                      {props.tripData.non_refund_deposite_date.slice(5, 10) +
                        "-" +
                        props.tripData.non_refund_deposite_date.slice(0, 4)}
                    </Typography>
                  </Typography>
                  <Typography
                    variant="h7"
                    style={{
                      fontWeight: "bold",
                      marginTop: "10px",
                      textAlign: "left",
                    }}
                  >
                    For
                    <Typography
                      variant="subtitle1"
                      style={
                        {
                          // border: "1px solid black",
                        }
                      }
                    >
                      Field Trip
                    </Typography>
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                direction="row"
                justifyContent="space-between"
                style={{
                  marginTop: "30px",
                  borderTop: "1px solid rgb(44, 129, 226)",
                  borderBottom: "4px solid  rgb(44, 129, 226)",
                }}
              >
                <Typography
                  style={{
                    margin: 0,
                    padding: "5px 10px 0px 5px",
                    color: "rgb(12, 118, 240) ",
                    fontWeight: "bold",
                  }}
                  variant="h7"
                >
                  Description
                </Typography>
                <Typography
                  style={{
                    margin: 0,
                    padding: "5px 10px 5px 0px",
                    color: "rgb(12, 118, 240) ",
                  }}
                  variant="h7"
                >
                  Amount
                </Typography>
              </Stack>
              <Stack>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  style={{
                    // marginTop: "30px",
                    borderTop: "1px solid gray",
                    borderBottom: "1px solid gray",
                  }}
                >
                  <Typography
                    style={{
                      margin: 0,
                      padding: "5px 10px 0px 5px",
                      maxWidth: "400px",
                    }}
                    variant="h7"
                    textAlign="left"
                  >
                    {props.tripData.guestCount} Children @
                    {usdFormatter.format(props.tripData.costPerGuest)} ( Field
                    Trip on {props.tripData.date.slice(5)})
                  </Typography>
                  <Typography
                    style={{
                      margin: 0,
                      padding: "5px 10px 5px 0px",
                    }}
                    variant="h7"
                  >
                    {usdFormatter.format(ticketsCharge)}
                  </Typography>
                </Stack>
                {!props.tripData.items
                  ? null
                  : props.tripData.items.map((i) => (
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        style={{
                          // marginTop: "30px",
                          borderBottom: "1px solid gray",
                        }}
                      >
                        <Typography
                          style={{
                            margin: 0,
                            padding: "5px 10px 0px 5px",
                            maxWidth: "400px",
                          }}
                          variant="h7"
                          textAlign="left"
                        >
                          {i.description}
                        </Typography>
                        <Typography
                          style={{
                            margin: 0,
                            padding: "5px 10px 5px 0px",
                          }}
                          variant="h7"
                        >
                          {usdFormatter.format(i.price)}
                        </Typography>
                      </Stack>
                    ))}

                <Stack
                  direction="row"
                  justifyContent="space-between"
                  style={{
                    marginTop: "30px",
                    borderBottom: "1px solid gray",
                  }}
                >
                  <Typography
                    style={{
                      padding: "5px 10px 0px 560px",
                      maxWidth: "400px",
                    }}
                    variant="h7"
                    textAlign="left"
                  >
                    Tax 6%:
                  </Typography>
                  <Typography
                    style={{
                      margin: 0,
                      padding: "5px 10px 5px 0px",
                    }}
                    variant="h7"
                  >
                    {props.tripData.taxFree
                      ? ""
                      : usdFormatter.format(totalCharge * 0.06)}
                  </Typography>
                </Stack>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  style={{
                    // marginTop: "30px",
                    borderBottom: "1px solid gray",
                  }}
                >
                  <Typography
                    style={{
                      padding: "5px 10px 0px 560px",
                      maxWidth: "400px",
                    }}
                    variant="h7"
                    textAlign="left"
                  >
                    {" "}
                    Subtotal:{" "}
                  </Typography>
                  <Typography
                    style={{
                      margin: 0,
                      padding: "5px 10px 5px 0px",
                    }}
                    variant="h7"
                  >
                    {props.tripData.taxFree
                      ? usdFormatter.format(totalCharge)
                      : usdFormatter.format(totalCharge * 0.06 + totalCharge)}
                  </Typography>
                </Stack>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  style={{
                    // marginTop: "30px",
                    borderBottom: "1px solid gray",
                  }}
                >
                  <Typography
                    style={{
                      padding: "5px 10px 0px 560px",
                      maxWidth: "400px",
                    }}
                    variant="h7"
                    textAlign="left"
                  >
                    {" "}
                    Deposit:{" "}
                  </Typography>
                  <Typography
                    style={{
                      margin: 0,
                      padding: "5px 10px 5px 0px",
                    }}
                    variant="h7"
                  >
                    {usdFormatter.format(non_refundable_deposit)}
                  </Typography>
                </Stack>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  style={{
                    // marginTop: "30px",
                    borderBottom: "1px solid gray",
                  }}
                >
                  <Typography
                    style={{
                      padding: "5px 10px 0px 560px",
                      maxWidth: "400px",
                    }}
                    variant="h7"
                    textAlign="left"
                  >
                    {" "}
                    Balance:{" "}
                  </Typography>
                  <Typography
                    style={{
                      margin: 0,
                      padding: "5px 10px 5px 0px",
                    }}
                    variant="h7"
                  >
                    {props.tripData.taxFree
                      ? usdFormatter.format(
                          non_refundable_deposit + totalCharge,
                        )
                      : usdFormatter.format(
                          non_refundable_deposit +
                            totalCharge +
                            totalCharge * 0.06,
                        )}
                    {/* {usdFormatter.format(
                      non_refundable_deposit + totalCharge + totalCharge * 0.06,
                    )} */}
                  </Typography>
                </Stack>
                <Typography
                  style={{
                    margin: 0,
                    padding: "10px 10px 5px 0px",
                  }}
                  variant="h7"
                >
                  Note: Payment of the remaining balance and signing the waiver
                  are required upon arrival.
                </Typography>
              </Stack>
            </Stack>
            <Stack justifyContent="flex-end">
              <Stack direction="row">
                <Typography variant="subtitle1" style={{ textAlign: "left" }}>
                  {`Please make check payable to `}
                </Typography>
                <Typography
                  variant="subtitle1"
                  style={{
                    marginLeft: "5px",
                    fontWeight: "bold",
                    textAlign: "left",
                  }}
                >
                  Leadkiddo Oasis LLC D/B/A Candyland Adventure
                </Typography>
              </Stack>

              <Typography variant="subtitle1" style={{ textAlign: "left" }}>
                If you have any questions or concerns regarding this invoice,
                contact us at 484-235-5550
              </Typography>
              <Typography
                variant="subtitle1"
                style={{ color: "rgb(12, 118, 240) ", textAlign: "center" }}
              >
                Thank you for your business!
              </Typography>
            </Stack>

            <style>
              {`
            @media print {
              body {
                margin: 0;   // Remove margin for print
                padding: 0;
              }
              .MuiModal-root {
                display: none; // Hide the modal during print
              }
              .MuiPaper-root {
                margin: 0;  // Remove margin to ensure it fits within one page
                padding: 0; // Remove padding for print, unless you want it
                width: 210mm; // A4 width
                height: 297mm; // A4 height
                overflow: hidden; // Prevent overflow
                box-sizing: border-box;
                border: none;  // Ensure no border is printed
              }
              // Remove any extra page breaks or spaces
              @page {
                size: A4;
                margin: 0; // Ensure there's no extra margin
              }
            }
          `}
            </style>
          </Stack>
        </Box>
      </Modal>

      <Stack>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setOpen(true)}
        >
          Preview
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenAndPrint} // Ensures modal opens first
          style={{ marginTop: "10px" }}
        >
          Print Invoice
        </Button>
      </Stack>
    </Container>
  );
};

export default InvoiceModal;
